import { SalesRepresentative } from "store/features/materialSpecs/ad/interfaces";

export interface BriefingFormModel {
    salesRep: SalesRepresentative;
    adSize: AdSize;
    adDesign: AdDesign;
    digitalBrief: DigitalBrief;
}

export interface MatSpecBriefingFormUpdateModel extends BriefingFormModel {
    materialSpecificationId: number;
}

export interface BriefingFormAssetModel extends BriefingFormModel {
    materialSpecificationId: number;
    file?: File;
    modifiedAssetIndex?: number;
    assetId?: number;
    removeFromArray?: boolean;
}

export interface BriefingFormAdditionalAssetsModel extends BriefingFormModel {
    materialSpecificationId: number;
    files: File[];
}

export interface JobDetails {
    customer: string;
    dueDate: Date;
}

export interface AdSize {
    type: AdSizeType;
    sizes: string[];
    otherDescription?: string;
}

export interface AdDesign {
    type: AdDesignType;
    complexity: AdDesignComplexity;
}

export interface DigitalBrief {
    ioNumber: string;
    assets: Assets[];
    callToAction: string;
    landingURL: string;
    specialInstructions: string;
}

export interface Assets {
    id: number | null;
    fileName: string | null;
    copyText?: string;
}

export type AdSizeType = "BUNDLE" | "BESPOKE";

export type AdDesignType = "STATIC" | "ANIMATED";

export type AdDesignComplexity = "EASY" | "MODERATE" | "DIFFICULT";

export const MAIN_ASSETS_LENGTH = 3;
